var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeInactivecomponent = function SvgHomeInactivecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m18 8.488-8-6.222-8 6.222V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zM20 19a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8a1 1 0 0 1 .386-.79l9-7c.36-.28.867-.28 1.228 0l9 7A1 1 0 0 1 20 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 21v-9H8v9a1 1 0 0 1-2 0V11a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0"
  })));
};
export default SvgHomeInactivecomponent;